<div *ngIf="!onExtendedMobile()" class="flex align-items-center gap-1">
	<div class="flex align-items-center">
		<label id="textMTMACloudProgress" *ngIf="isMTMAConnect() && progress!==undefined" class="font-medium mr-1">
			{{progress}}
			<p-progressBar mode="indeterminate" [style]="{'height': '6px', 'width': '10rem'}" />
		</label>
		<div id="MTMAUpdatingFwProgress" *ngIf="isMTMAConnect() && onFirmwareUpdate()"
			class="flex align-items-center gap-3 mx-3" pTooltip="{{'UPDATE_FIRWARE_MTMA_PROGRESS' | translate }}"
			tooltipPosition="bottom">
			<div class="pi cm-update-firmware text-2xl text-yellow-600"></div>
			<p-progressBar mode="indeterminate"
				[style]="{'height': '6px', 'width': '10rem', 'background-color': '#FFE4AE'}" />
		</div>
		<p-button id="buttonMTMACloud" *ngIf="isMTMAConnect()" [disabled]="isDeviceUnavailable() || onFirmwareUpdate()"
			pTooltip="{{ getTextMtmaWriteConfig() }}" tooltipPosition="bottom" icon="pi {{getIconMtmaWriteConfig()}}"
			size="large" (click)="writeConfig()" [rounded]="false" [text]="false" [severity]="getColorMtmaWriteConfig()">
		</p-button>
	</div>
	<p-button id="buttonDeviceListView" pTooltip="{{ 'BACK_TO_DEVICES' | translate }}" tooltipPosition="bottom"
		icon="pi cm-arrow-left" size="large" (click)="toDeviceList()" [rounded]="false" [text]="true"
		severity="secondary">
	</p-button>
	<p-button id="buttonDeviceSlaveAdd" *ngIf="supportAddChildren() && device.CurrentlyOwned" [label]="getAddLabel()"
		[disabled]="!canAddChild()" icon="pi cm-plus" size="large" (click)="addDevice()" [rounded]="false" [text]="true"
		severity="primary" styleClass="font-bold border-primary surface-900 hover:bg-blue-900">
	</p-button>
	<p-button id="buttonDeviceNotification" *ngIf="device.CurrentlyOwned" pTooltip="{{ 'EVENTS' | translate }}"
		tooltipPosition="bottom" icon="pi cm-bell" size="large" (click)="toEventsList()" [rounded]="false" [text]="true"
		severity="secondary">
	</p-button>
	<p-button id="buttonDeviceNotification" *ngIf="device.CurrentlyOwned && hasTasks()"
		pTooltip="{{ 'TASKS' | translate }}"
		[styleClass]="runningTasksCount > 0 ? runningTasksCount > 9 ? 'pb-0 pl-1 pr-3' : 'pb-0 px-2' : 'px-2 py-2'"
		tooltipPosition="bottom" size="large" (click)="tasks()" [rounded]="false" [text]="true" severity="secondary">
		<span class="flex flex-row">
			<i class="pi text-2xl cm-cloud-progress" [class]="runningTasksCount > 0 ? 'pt-1' : ''"></i>
			<p-badge [value]="runningTasksCount" styleClass="p-badge-topbar text-sm pt-0 ml-0"
				*ngIf="runningTasksCount > 0"
				[class]="runningTasksCount > 99 ? 'absolute top-0 ml-0' : 'absolute top-0 ml-2'" severity="danger">
			</p-badge>
		</span>
	</p-button>
	<p-button id="buttonDeviceShare" *ngIf="sharable() && device.CurrentlyOwned" [disabled]="!configured()"
		pTooltip="{{ 'SHARE_DEVICE' | translate }}" tooltipPosition="bottom" icon="pi cm-share" size="large"
		(click)="share()" [rounded]="false" [text]="true" severity="secondary">
	</p-button>
	<!--<p-button id="buttonPasswordEdit" *ngIf="passwordSupport && deviceStatus.Online && (isTechnician || impersMode)"
			pTooltip="{{ 'EDIT_PASSWORD' | translate }}" tooltipPosition="bottom" icon="pi cm-key" size="large"
			(click)="editPassword()" [rounded]="false" [text]="true" severity="secondary">
		</p-button>-->
	<p-button id="buttonDeviceEdit" [disabled]="!device.CurrentlyOwned" pTooltip="{{ 'EDIT_DEVICE' | translate }}"
		tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editDevice()" [rounded]="false" [text]="true"
		severity="secondary">
	</p-button>
	<p-button id="buttonDeviceDelete" *ngIf="device.CurrentlyOwned" [disabled]="isIOMtma()"
		pTooltip="{{ 'DELETE_DEVICE' | translate }}" tooltipPosition="bottom" icon="pi cm-trash" size="large"
		(click)="delete()" [rounded]="false" [text]="true" severity="danger">
	</p-button>
	<p-button id="buttonDeviceDeleteShare" *ngIf="canRemoveShare()" pTooltip="{{ 'DELETE_DEVICE' | translate }}"
		tooltipPosition="bottom" icon="pi cm-trash" size="large" (click)="removeShare()" [rounded]="false" [text]="true"
		severity="danger">
	</p-button>
</div>

<div *ngIf="onExtendedMobile()" class="flex justify-content-end px-0">
	<button pButton pRipple icon="pi cm-ellipsis-v" class="p-button-text text-color"
		(click)="menu.toggle($event)"></button>
	<p-menu #menu [popup]="true" appendTo="body" [model]="menuitems"></p-menu>
</div>

<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>